import React, { useEffect, useRef, useState } from "react";
// @material-ui/core components
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import DoneIcon from "@material-ui/icons/Done";
// core components
import {
  Grid,
  IconButton,
  Button,
  TableContainer,
  TablePagination,
  Tooltip,
  makeStyles,
  Chip,
  Typography,
  Paper,
  TableSortLabel,
  LinearProgress,
} from "@material-ui/core";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import DeleteSweepOutlinedIcon from "@material-ui/icons/DeleteSweepOutlined";
import CreateIcon from "@material-ui/icons/Create";
import Box from "@material-ui/core/Box";
import Collapse from "@material-ui/core/Collapse";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";

const useStyles = makeStyles((theme) => ({
  root: { width: "100%", minWidth: 0, overflow: "hidden" },
  container: { maxHeight: "65vh", overflow: "auto", width: "100%" },
  table: {
    minWidth: 1000,
    "& > thead > tr > th": {
      backgroundColor: theme.palette.background.default,
      fontWeight: theme.typography.fontWeightMedium,
      textAlign: "center",
      whiteSpace: "nowrap",
    },
    "& > tbody > tr > td": {
      borderBottom: "1px solid " + theme.palette.divider,
    },
  },
  pagination: {
    width: "100%",
    borderTop: "1px solid " + theme.palette.divider,
    "& .MuiTablePagination-toolbar": {
      paddingLeft: theme.spacing(1),
      flexWrap: "wrap",
      justifyContent: "flex-end",
    },
    "& .MuiTablePagination-spacer": { flex: "1 1 auto" },
    "& .MuiTablePagination-actions": { marginLeft: theme.spacing(1) },
  },
  state: { padding: theme.spacing(4), textAlign: "center" },
  header: {
    fontSize: "14px",
    fontWeight: "550",
    marginTop: "1rem",
    marginBottom: "1rem",
  },
  tabelCellFont: {
    fontSize: theme.typography.body2.fontSize,
  },
  PName: {
    fontSize: "12px",
    fontWeight: "550",
    textTransform: "capitalize",
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
}));

function EnhancedTableHead({
  classes,
  order,
  orderBy,
  onRequestSort,
  headCells,
  loading,
}) {
  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => {
          const sortField = headCell.sortBy || headCell.id;
          const active = orderBy === sortField;
          return (
            <TableCell
              align="center"
              key={headCell.id}
              padding={headCell.disablePadding ? "none" : "normal"}
              sortDirection={active ? order : false}
            >
              <TableSortLabel
                disabled={loading}
                active={active}
                direction={active ? order : "asc"}
                onClick={(event) => onRequestSort(event, sortField)}
              >
                {headCell.label}
                {active ? (
                  <span className={classes.visuallyHidden}>
                    {order === "desc"
                      ? "sorted descending"
                      : "sorted ascending"}
                  </span>
                ) : null}
              </TableSortLabel>
            </TableCell>
          );
        })}
        <TableCell align="center">Details</TableCell>
      </TableRow>
    </TableHead>
  );
}

function Row(props) {
  const {
    row,
    tableHead,
    orderStatus,
    classes,
    handleBlockUser,
    changeOrderStatusClick,
    changeOrderItemStatusClick,
    loading,
  } = props;
  const [open, setOpen] = React.useState(false);
  const [orderStatusSelected, setOrderStatusSelected] = useState("");

  const handleOrderStatusChange = (e) => {
    console.log(e, "id to change status");
    setOrderStatusSelected(e.target.value);
  };
  return (
    <React.Fragment>
      <TableRow hover>
        {tableHead &&
          tableHead.map((column, key) => {
            const value = row[column.id];

            switch (column.id) {
              case "action":
                return (
                  <TableCell
                    key={key}
                    align="center"
                    style={{
                      minWidth: column.minWidth,
                      borderBottom: "none",
                    }}
                  >
                    <Tooltip title="Delete" arrow>
                      <IconButton
                        aria-label="Delete"
                        color="primary"
                        // onClick={() => {
                        // 	DeleteDailog(true);
                        // 	Delete && Delete(row.id);
                        // }}
                      >
                        <DeleteSweepOutlinedIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Edit" arrow>
                      <IconButton
                        aria-label="delete"
                        color="primary"
                        // onClick={() => {
                        // 	setHandCloseDailog(true);
                        // 	ActionFunction &&
                        // 	dispatch(ActionFunction(row.id));
                        // 	props.setID && props.setID(row.id);
                        // 	console.log(row.id, 'row id');
                        // }}
                      >
                        <CreateIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                );
              case "actionOrderStatus":
                return (
                  <TableCell
                    key={key}
                    align="center"
                    style={{ minWidth: 250, borderBottom: "none" }}
                  >
                    <FormControl style={{ minWidth: 150 }}>
                      <Select
                        value={orderStatusSelected}
                        onChange={(e) => handleOrderStatusChange(e)}
                        inputProps={{ "aria-label": "Without label" }}
                      >
                        <MenuItem value="" disabled>
                          Status
                        </MenuItem>
                        {orderStatus.length &&
                          orderStatus.map((x) => {
                            return <MenuItem value={x}>{x}</MenuItem>;
                          })}
                        {/* <MenuItem value={20}>Twenty</MenuItem>
                        <MenuItem value={30}>Thirty</MenuItem> */}
                      </Select>
                    </FormControl>
                    <Button
                      variant="contained"
                      size="small"
                      color="primary"
                      style={{ marginLeft: "10px" }}
                      onClick={() =>
                        changeOrderStatusClick(row._id, orderStatusSelected)
                      }
                    >
                      Change
                    </Button>
                  </TableCell>
                );
              case "actionBlockUser":
                return (
                  <TableCell
                    key={key}
                    align="center"
                    style={{
                      minWidth: column.minWidth,
                      borderBottom: "none",
                    }}
                  >
                    <Tooltip title="Block/Unblock" arrow>
                      <FormControlLabel
                        control={
                          <Switch
                            disabled={loading}
                            size="small"
                            checked={row.checked}
                            onChange={(e) =>
                              handleBlockUser(row._id, !row.checked)
                            }
                          />
                        }
                      />
                    </Tooltip>
                  </TableCell>
                );

              case "actionBookUser":
                return (
                  <TableCell
                    key={key}
                    align="center"
                    style={{
                      minWidth: column.minWidth,
                    }}
                  >
                    <Tooltip title="Book/Unbook" arrow>
                      <FormControlLabel
                        control={
                          <Switch
                            disabled={loading}
                            size="small"
                            inputProps={{
                              "aria-label": "Book order " + row.invoiceNo,
                            }}
                            checked={row.isBooked}
                            onChange={(e) =>
                              changeOrderItemStatusClick(
                                row._id,
                                "isBooked",
                                !row.isBooked,
                              )
                            }
                          />
                        }
                      />
                    </Tooltip>
                  </TableCell>
                );
              case "actionConfirmOrder":
                return (
                  <TableCell
                    key={key}
                    align="center"
                    style={{
                      minWidth: column.minWidth,
                    }}
                  >
                    <Tooltip title="Confirm" arrow>
                      <FormControlLabel
                        control={
                          <Switch
                            disabled={loading}
                            size="small"
                            inputProps={{
                              "aria-label": "Confirm order " + row.invoiceNo,
                            }}
                            checked={row.isOrderConfirmed}
                            onChange={(e) =>
                              changeOrderItemStatusClick(
                                row._id,
                                "isOrderConfirmed",
                                !row.isOrderConfirmed,
                              )
                            }
                          />
                        }
                      />
                    </Tooltip>
                  </TableCell>
                );

              case "coverPhoto":
                return (
                  <TableCell
                    key={key}
                    align="center"
                    style={{ borderBottom: "none" }}
                  >
                    {
                      <img
                        src={value?.imgurl}
                        width="70px"
                        height="50px"
                        style={{ objectFit: "cover" }}
                        alt={value?.title}
                      />
                    }
                  </TableCell>
                );

              case "createdAt":
                return (
                  <TableCell
                    key={key}
                    align="center"
                    style={{
                      minWidth: column.minWidth,
                      borderBottom: "none",
                    }}
                  >
                    {value ? new Date(value).toLocaleDateString() : "-"}
                  </TableCell>
                );

              case "dateOfMove":
                return (
                  <TableCell
                    key={key}
                    align="center"
                    style={{
                      minWidth: column.minWidth,
                      borderBottom: "none",
                    }}
                  >
                    {value ? new Date(value).toLocaleDateString() : "-"}
                  </TableCell>
                );

              case "timeOfMove":
                return (
                  <TableCell
                    key={key}
                    align="center"
                    style={{
                      minWidth: column.minWidth,
                      borderBottom: "none",
                    }}
                  >
                    {value == 1
                      ? "Morning (7 - 9)"
                      : value == 2
                      ? "Afternoon (12 - 3)"
                      : "Evening (5 - 7)"}
                  </TableCell>
                );

              case "variation":
                return (
                  <TableCell
                    key={key}
                    align="center"
                    style={{
                      minWidth: column.minWidth,
                      borderBottom: "none",
                    }}
                  >
                    <Typography className={classes.tabelCellFont}>
                      Name: {value[0]?.name}
                      <br />
                      Price: {value[0]?.variance?.price}
                      <br />
                      Stock: {value[0]?.variance?.stock}
                    </Typography>
                  </TableCell>
                );

              case "status":
                return (
                  <TableCell
                    key={key}
                    align="center"
                    style={{
                      minWidth: column.minWidth,
                      borderBottom: "none",
                    }}
                  >
                    {value === "pending" || value === "cancelled" ? (
                      <Chip
                        // onDelete={() => handleLive()}
                        color="secondary"
                        label={
                          <Typography
                            style={{
                              fontSize: "11px",
                              color: "#fff",
                            }}
                          >
                            {value}
                          </Typography>
                        }
                        size="small"
                      />
                    ) : (
                      <Chip
                        color="secondary"
                        label={value}
                        size="small"
                        // deleteIcon={<DoneIcon />}
                        // onDelete={() => handleDelisted()}
                      />
                    )}
                  </TableCell>
                );

              case "isBlocked":
                return (
                  <TableCell
                    key={key}
                    align="center"
                    style={{
                      minWidth: column.minWidth,
                      borderBottom: "none",
                    }}
                  >
                    <Typography className={classes.PName}>
                      {value == 1 ? "Yes" : "No"}
                    </Typography>
                  </TableCell>
                );
              case "name":
                return (
                  <TableCell
                    key={key}
                    align="center"
                    style={{
                      minWidth: column.minWidth,
                      borderBottom: "none",
                    }}
                  >
                    <Typography className={classes.PName}>
                      {value ? value : "-"}
                    </Typography>
                  </TableCell>
                );
              case "is_blocked":
                return (
                  <TableCell
                    key={key}
                    align="center"
                    style={{
                      minWidth: column.minWidth,
                      borderBottom: "none",
                    }}
                  >
                    <Typography className={classes.PName}>
                      {value == 0 ? "No" : "Yes"}
                    </Typography>
                  </TableCell>
                );
              case "isDrafted":
                return (
                  <TableCell
                    key={key}
                    align="center"
                    style={{
                      minWidth: column.minWidth,
                      borderBottom: "none",
                    }}
                  >
                    <Typography className={classes.PName}>
                      {value.toString()}
                    </Typography>
                  </TableCell>
                );

              default:
                return (
                  <TableCell
                    key={key}
                    align="center"
                    style={{
                      minWidth: column.minWidth,
                      borderBottom: "none",
                    }}
                  >
                    <Typography className={classes.tabelCellFont}>
                      {value ? value : "-"}
                    </Typography>
                  </TableCell>
                );
            }
          })}
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell
          style={{ paddingBottom: 0, paddingTop: 0 }}
          colSpan={tableHead.length + 1}
        >
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={3}>
              <Grid container>
                <Grid item xs={12} sm={6}>
                  <Typography className={classes.tabelCellFont}>
                    Mobile: {row.mobile}
                  </Typography>
                  <Typography className={classes.tabelCellFont}>
                    Description: {row.description}
                  </Typography>
                  <Typography className={classes.tabelCellFont}>
                    Workers Required: {row.workersRequired}
                  </Typography>
                  <Typography className={classes.tabelCellFont}>
                    Cargo: {row.cargoLifter}
                  </Typography>
                  <Typography className={classes.tabelCellFont}>
                    Created At: {new Date(row.createdAt).toLocaleString()}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography className={classes.tabelCellFont}>
                    Total Distance: {row.totalDistance}
                  </Typography>
                  <Typography className={classes.tabelCellFont}>
                    Total Volume: {row.totalVolume}
                  </Typography>
                  <Typography className={classes.tabelCellFont}>
                    Total Amount: {row.totalOrderAmount}
                  </Typography>
                  <Typography className={classes.tabelCellFont}>
                    <a
                      href={`${process.env.REACT_APP_HOST}${row.pdf}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Download Invoice
                    </a>
                  </Typography>
                </Grid>
              </Grid>
            </Box>
            <Box margin={3}>
              <Typography variant="h6" gutterBottom component="div">
                Order Items
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow className={classes.tableHeadRow}>
                    <TableCell className={classes.header}>Name</TableCell>
                    <TableCell className={classes.header}>Quantity</TableCell>
                    <TableCell className={classes.header} align="right">
                      Volume (m3)
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {row?.cargo?.map((orderItem) => (
                    <TableRow key={orderItem._id}>
                      <TableCell
                        component="th"
                        scope="row"
                        style={{ textTransform: "capitalize" }}
                      >
                        {orderItem.name}
                      </TableCell>
                      <TableCell>{orderItem.quantity}</TableCell>
                      <TableCell align="right">{orderItem.volume}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

function CustomTable(props) {
  const classes = useStyles();
  const {
    tableHead,
    tableData,
    Limit,
    Page,
    setPage,
    setLimit,
    total,
    loading,
    error,
    onRetry,
    order = "desc",
    orderBy = "createdAt",
    onRequestSort,
    // ActionFunction,
    handleLive,
    handleDelisted,
    handleBlockUser,
    // tableHeaderColor,
    // DeleteDailog,
    // Delete,
    // setHandCloseDailog,
    orderStatus,
    changeOrderStatusClick,
    orderItemStatus,
    changeOrderItemStatusClick,
  } = props;

  const containerRef = useRef(null);
  useEffect(() => {
    if (containerRef.current) containerRef.current.scrollTop = 0;
  }, [Page, Limit, order, orderBy]);
  const handleChangePage = (event, newPage) => {
    if (!loading) setPage(newPage + 1);
  };
  const handleChangeRowsPerPage = (event) => {
    if (!loading) setLimit(Number(event.target.value));
  };

  // *******************************************************************************************
  function SubRow(props) {
    const { orderItem, changeOrderItemStatusClick, orderItemStatus } = props;
    const [orderItemStatusSelected, setOrderItemStatusSelected] = useState("");

    const handleOrderItemStatusChange = (e) => {
      console.log(e, "id to change status");
      setOrderItemStatusSelected(e.target.value);
    };

    return (
      <>
        <FormControl style={{ minWidth: 150 }}>
          <Select
            value={orderItemStatusSelected}
            onChange={(e) => handleOrderItemStatusChange(e)}
            inputProps={{ "aria-label": "Without label" }}
          >
            <MenuItem value="" disabled>
              Status
            </MenuItem>
            {orderItemStatus.length &&
              orderItemStatus.map((x) => {
                return <MenuItem value={x}>{x}</MenuItem>;
              })}
            {/* <MenuItem value={20}>Twenty</MenuItem>
                          <MenuItem value={30}>Thirty</MenuItem> */}
          </Select>
        </FormControl>
        <Button
          variant="contained"
          size="small"
          color="primary"
          style={{ marginLeft: "10px" }}
          onClick={() =>
            changeOrderItemStatusClick(orderItem._id, orderItemStatusSelected)
          }
        >
          Change
        </Button>
      </>
    );
  }
  //   ****************************************UI********************************************
  return (
    <Grid
      item
      container
      component={Paper}
      variant="outlined"
      className={classes.root}
    >
      {loading && (
        <LinearProgress style={{ width: "100%" }} aria-label="Loading orders" />
      )}
      <TableContainer
        ref={containerRef}
        className={classes.container}
        aria-busy={loading}
      >
        <Table
          stickyHeader
          className={classes.table}
          size="small"
          aria-label="a dense table"
        >
          {tableHead !== undefined ? (
            <EnhancedTableHead
              classes={classes}
              order={order}
              orderBy={orderBy}
              onRequestSort={onRequestSort}
              loading={loading}
              rowCount={tableData.length}
              headCells={tableHead}
            />
          ) : // <TableHead>
          //   <TableRow className={classes.tableHeadRow}>
          //     {tableHead.map((prop, key) => {
          //       return (
          //         <TableCell align="center" key={key}>
          //           <Typography className={classes.header}>
          //             {prop.label}
          //           </Typography>
          //         </TableCell>
          //       );
          //     })}
          //     <TableCell align="left">
          //       <Typography className={classes.header}>Details</Typography>
          //     </TableCell>
          //   </TableRow>
          // </TableHead>
          null}
          <TableBody>
            {(loading || error || tableData.length === 0) && (
              <TableRow>
                <TableCell
                  colSpan={tableHead.length + 1}
                  className={classes.state}
                >
                  <Typography
                    role={error ? "alert" : "status"}
                    color={error ? "error" : "textSecondary"}
                  >
                    {loading ? "Loading orders…" : error || "No orders found."}
                  </Typography>
                  {!loading && error && (
                    <Button color="primary" onClick={onRetry}>
                      Retry
                    </Button>
                  )}
                </TableCell>
              </TableRow>
            )}
            {!error &&
              tableData &&
              tableData.map((row, index) => {
                return (
                  <Row
                    classes={classes}
                    handleBlockUser={handleBlockUser}
                    loading={loading}
                    key={row._id}
                    row={row}
                    tableHead={tableHead}
                    orderStatus={orderStatus}
                    changeOrderStatusClick={changeOrderStatusClick}
                    orderItemStatus={orderItemStatus}
                    changeOrderItemStatusClick={changeOrderItemStatusClick}
                  />
                  // <TableRow key={index} hover role="action" tabIndex={-1}>
                  //   <TableCell>
                  //     <IconButton
                  //       aria-label="expand row"
                  //       size="small"
                  //       onClick={() => setOpen(!open)}
                  //     >
                  //       {open ? (
                  //         <KeyboardArrowUpIcon />
                  //       ) : (
                  //         <KeyboardArrowDownIcon />
                  //       )}
                  //     </IconButton>
                  //   </TableCell>

                  // </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        className={classes.pagination}
        rowsPerPageOptions={[25, 50, 100]}
        component="div"
        count={total}
        rowsPerPage={Limit}
        page={Page - 1}
        SelectProps={{ disabled: loading }}
        backIconButtonProps={{ disabled: loading || Page <= 1 }}
        nextIconButtonProps={{ disabled: loading || Page * Limit >= total }}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Grid>
  );
}

export default React.memo(CustomTable);
